import $ from 'jquery';
import { detect } from 'detect-browser';

const $html = $('html');
const BROWSER = detect();

export function setBrowserClassToHTML() {
    $html.addClass(BROWSER.name);
}
